/*eslint-disable react/no-set-state*/
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {browserHistory} from 'react-router';
import * as FormName from '../../constants/formNameConstants';
import {searchForFormById} from '../../selectors/searchForForm';
import * as helpDeskActions from '../../actions/helpDeskActions';
import * as pathConstants from '../../constants/pathConstants';
import mode from '../../api/mode';
import HelpRequestForm from './HelpRequestForm';
import * as errorMessages from '../../constants/errorMessages';
import '../../styles/helpRequest/helpRequest.css';

export class HelpRequestPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: props.data,
      formIsValid: false,
      activeFields: [],
      errors: {},
      emailSent: false
    };

    this.enteringData = this.enteringData.bind(this);
    this.redirect = this.redirect.bind(this);
    this.googleReCaptchaCallback = this.googleReCaptchaCallback.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.setActiveFields = this.setActiveFields.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.submitData = this.submitData.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  confirmFormIsValid(data, requiredFields, activeFields) {
    let formIsValid = true;
    let errors = {};
    requiredFields.map(questionPart => {
      let fieldName = questionPart.questionPartName;
      let label = questionPart.questionPartLabel == "State" ? "Your Location" : questionPart.questionPartLabel;
      if (!data[fieldName] && data[fieldName] !== 0) {
        formIsValid = false;
        if (activeFields.indexOf(fieldName) !== -1) {
          errors[fieldName] = label + errorMessages.ERROR_NEEDS_VALUE;
        }
      }
    });
    //firstName, lastName, Comments empty spaces validation
    if(/[a-zA-Z]{2,}/.test(data.firstName) == false) {
      formIsValid = false;
      errors.firstName = "First Name" + errorMessages.ERROR_NEEDS_VALUE;
    }
    if(/^\s/.test(data.firstName)){
      formIsValid = false;
      errors.firstName = "First Name cannot begin with a space.";
    }
    if (/[a-zA-Z]{2,}/.test(data.lastName) == false) {
      formIsValid = false;
      errors.lastName = "Last Name" + errorMessages.ERROR_NEEDS_VALUE;
    }
    if(/^\s/.test(data.lastName)){
      formIsValid = false;
      errors.lastName = "Last Name cannot begin with a space.";
    }
    if(/[a-zA-Z]{2,}/.test(data.message) == false) {
      formIsValid = false;
      errors.message = "Your Question or Comment" + errorMessages.ERROR_NEEDS_VALUE;
    }
    if (data.phoneNumber && (data.phoneNumber.match(/[A-Za-z]/g) || data.phoneNumber.match(/\d/g).length !== 10)) {
      formIsValid = false;
      errors.phoneNumber = errorMessages.ERROR_PHONE_NUMBER_NOT_CORRECT;
    }
    //email validation
    let re = new RegExp('[A-Z0-9._%+-]+@[A-Z0-9.-]+[\.][A-Z]{2,}', 'i');
    if (data.email && data.email.search(re) == -1) {
      formIsValid = false;
      errors.email = errorMessages.ERROR_INVALID_EMAIL;
    }
    if (activeFields.indexOf('emailConfirmation') != -1
      && data.email !== data.emailConfirmation) {
      formIsValid = false;
      errors.emailConfirmation = errorMessages.ERROR_EMAILS_NOT_MATCHED;
    }
    if (!data.googleCaptcha && this.props.userGoogleCaptcha) {
      formIsValid = false;
    }
    return {formIsValid, errors};
  }

  enteringData(event) {
    event.preventDefault();
    const field = event.target.name;
    let data = this.state.data;
    data[field] = event.target.value;
    this.setActiveFields(field);
    this.setState({data: data});
    this.setState({formIsValid: this.confirmFormIsValid(this.state.data, this.props.requiredFields, this.state.activeFields).formIsValid});
    this.setState({errors: this.confirmFormIsValid(this.state.data, this.props.requiredFields, this.state.activeFields).errors});
  }

  googleReCaptchaCallback(key) {
    let data = this.state.data;
    data.googleCaptcha = key;
    this.setState({data: data});
    this.setState({formIsValid: this.confirmFormIsValid(this.state.data, this.props.requiredFields, this.state.activeFields).formIsValid});
    this.setState({errors: this.confirmFormIsValid(this.state.data, this.props.requiredFields, this.state.activeFields).errors});
  }

  handleClick(event) {
    const field = event.target.name;
    let data = this.state.data;
    data[field] = event.target.value;
    this.setActiveFields(field);
    this.setState({data: data});
    this.setState({formIsValid: this.confirmFormIsValid(this.state.data, this.props.requiredFields, this.state.activeFields).formIsValid});
    this.setState({errors: this.confirmFormIsValid(this.state.data, this.props.requiredFields, this.state.activeFields).errors});
  }

  handleOnBlur(event) {
    event.preventDefault();
    const field = event.target.name;
    this.setActiveFields(field);
    this.setState({formIsValid: this.confirmFormIsValid(this.state.data, this.props.requiredFields, this.state.activeFields).formIsValid});
    this.setState({errors: this.confirmFormIsValid(this.state.data, this.props.requiredFields, this.state.activeFields).errors});
  }

  setActiveFields(field) {
    let activeFields = this.state.activeFields;
    if (activeFields.indexOf(field) == -1) {
      activeFields.push(field);
      this.setState({activeFields: activeFields});
    }
  }

  submitData(event) {
    event.preventDefault();
    this.props.actions.sendHelpDeskInformation(this.state.data)
      .then(response => {
        if(response.success) {
          let newData = Object.assign({}, this.state.data);
          newData.topic = undefined;
          newData.message = undefined;
          this.setState({
            emailSent: true,
            data: newData,
          });
          browserHistory.push(pathConstants.pathToHelpRequestConfirm);
          window.scrollTo(0,0);
        }
        return response;
      }).catch(error => {
      throw error;
    });
  }
  onCancel(event){
    event.preventDefault();
    this.redirect();
  }
  redirect() {
    browserHistory.push(pathConstants.pathToHome);
  }

  render() {
    return (
      <div>
        <HelpRequestForm
          contactData={this.state.data}
          form={this.props.helpRequestForm}
          onSubmit={this.submitData}
          onChange={this.enteringData}
          onClick={this.handleClick}
          onBlur={this.handleOnBlur}
          onCancel={this.onCancel}
          reCaptchaCallback={this.googleReCaptchaCallback}
          submitStatus={this.state.formIsValid}
          errors={this.state.errors}
          emailSent={this.state.emailSent}
        />
      </div>
    );
  }
}

HelpRequestPage.propTypes = {
  actions: PropTypes.object.isRequired,
  helpRequestForm: PropTypes.object.isRequired,
  requiredFields: PropTypes.array,
  data: PropTypes.object,
  userGoogleCaptcha: PropTypes.bool.isRequired,
};
function mapStateToProps(state) {
  let helpRequestForm = {},
    requiredFields = [];
  let user = state.user.slice(-1)[0] || {};
  let data = {};
  data.firstName = user.firstName || "";
  data.lastName = user.lastName || "";
  data.phoneNumber = user.telephone || "";
  data.email = user.email || "";
  data.emailConfirmation = user.email || "";
  let userGoogleCaptcha = true;
  const currentLocation = window ? window.location.host : null;
  if (!mode.prod
    && currentLocation !== 'test.osha.gov'
    && currentLocation !== 'www.osha.gov') {
    userGoogleCaptcha = false;
  }
  if (state.forms.length > 0) {
    helpRequestForm =
      searchForFormById(state.forms, FormName.helpRequestFormId);
  }
  if (helpRequestForm && helpRequestForm.formQuestions) {
    requiredFields = [].concat.apply([], helpRequestForm.formQuestions.map(question => {
      return question.questionParts.map(questionPart => {
        return questionPart;
      }).filter(questionPart => {
        return questionPart;
      });
    }));
  }
  return {
    helpRequestForm,
    requiredFields,
    userGoogleCaptcha,
    data
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(helpDeskActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpRequestPage);



/** WEBPACK FOOTER **
 ** ./src/components/helpRequest/HelpRequestPage.js
 **/